'use client';

import React from 'react';

import { QRCodeCanvas } from 'qrcode.react';

import Link from 'next/link';

import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export type QrLinkItem = {
    label: string;
    url: string;
};

export type QrLinksBlockProps = {
    title?: string;
    items: QrLinkItem[];
    className?: string;
};

export const QrLinksBlock: React.FC<QrLinksBlockProps> = ({ title, items, className }) => {
    if (!items?.length) return null;

    return (
        <section className={cn('my-8 w-full clear-both', className)}>
            {title ? <h3 className="text-2xl font-semibold mb-6">{title}</h3> : null}
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {items.map((item, index) => {
                    const value = item.url?.trim();
                    if (!value) return null;

                    return (
                        <Card key={`${value}-${index}`} className="h-full">
                            <CardContent className="flex flex-col items-center gap-3">
                                <QRCodeCanvas
                                    value={value}
                                    size={220}
                                    imageSettings={{
                                        src: '/web-app-manifest-192x192.png',
                                        height: 60,
                                        width: 60,
                                        excavate: true,
                                    }}
                                    level="H"
                                />
                                <Link href={value} target="_blank" className="text-sm text-muted-foreground break-all">
                                    {item.label}
                                </Link>
                            </CardContent>
                        </Card>
                    );
                })}
            </div>
        </section>
    );
};
